export class RogueRecommendationTypes {
  id: number;
  recommendationType: string;
  recommendationDisplay: string;
  updateTimestamp: Date;
}
